import { Dispatch } from "redux";
export const localAction =
  (actionType: string, payload: any) => (dispatch: Dispatch) =>
    dispatch({
      type: actionType,
      payload,
    });
